<section [formGroup]="formGroup" class="layout-grid">
    <mat-form-field
        appearance="standard"
        floatLabel="always"
        class="card-holder-name">
        <mat-label>{{ CC_FIELDS.ccname }}</mat-label>
        <input
            matInput
            [formControlName]="CC_FIELDS.ccname"
            required
            maxlength="50"
            placeholder="Name as shown on card"/>
        <mat-error
            *ngIf="formGroup.controls?.[CC_FIELDS.ccname]?.touched && formGroup?.controls?.[CC_FIELDS.ccname]?.invalid">
            {{validationService.getFieldErrorMessage(CC_FIELDS.ccname,
            formGroup.controls[CC_FIELDS.ccname])}}
        </mat-error>
    </mat-form-field>

    <div class="payment-method-details__card-info">
        <mat-form-field appearance="standard" class="vgs-iframe-field">
            <mat-label>{{ CC_FIELDS.ccnumber }} *</mat-label>
            <app-payment-integration-form-field
                formControlName="ccnumber"
                [id]="'vgsCCNumber'"
                [loaded]="!loading"
                field-min-size="15">
            </app-payment-integration-form-field>
            <mat-error>
                {{getFieldError('ccnumber')}}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="standard" class="vgs-iframe-field">
            <mat-label>{{ CC_FIELDS.ccexp }} *</mat-label>
            <app-payment-integration-form-field
                formControlName="ccexp"
                [id]="'vgsCCExp'"
                [loaded]="!loading"
                field-min-size="15">
            </app-payment-integration-form-field>
            <mat-error>
                {{getFieldError('ccexp')}}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="standard" class="vgs-iframe-field">
            <mat-label>{{ CC_FIELDS.cvv }} *</mat-label>
            <app-payment-integration-form-field
                formControlName="cvv"
                [id]="'vgsCVC'"
                [loaded]="!loading"
                field-min-size="15">
            </app-payment-integration-form-field>
            <mat-error>
                {{getFieldError('cvv')}}
            </mat-error>
        </mat-form-field>
    </div>

    <div class="cvv-instructions cvv-instructions--short">
        <div class="cvv-instructions__note">
            <teller-online-icon-info></teller-online-icon-info>
            <span>Where do I find the CVV?</span>
        </div>
        <img
            class="cvv-instructions__sample"
            src="assets/images/CVV.png"
            alt="Sample credit card image showing where cvv is"
        />
    </div>

    <ng-container
        *ngIf="allowSavePaymentMethod && formGroup?.controls?.rememberPaymentMethod">
        <div
            class="remember-payment-method"
            formGroupName="rememberPaymentMethod">
            <mat-checkbox formControlName="checked">Save credit card information</mat-checkbox>
        </div>
    </ng-container>
</section>
